module.exports = __webpack_public_path__ + "static/media/7.bd2b8959.JPG";